module.exports = __webpack_public_path__ + "img/2.821b2551.png";